Monitoring.Views ||= {}

class Monitoring.Views.ReviewQueueDefinitionEditView extends Backbone.View
  template: JST["backbone/templates/moderation/review_queue_definitions/review_queue_definition_edit_modal"]

  events:
    'click .save': 'onClickSave'

  initialize: (@options = {}) ->
    @reviewQueueDefinition = @options.reviewQueueDefinition
    @availableTopics = @options.availableTopics
    @availableTags   = @options.availableTags
    @availableGroups = @options.availableGroups
    @availableSubtypes = @options.availableSubtypes
    @availableUsers = @options.availableUsers
    @availableUsersGroups = @options.availableUsersGroups
    @availableSentiments = _.map(['negative', 'neutral', 'positive', 'missing'], (s) ->
      {
        name: I18n.t('monitoring.rules.sentiments.' + s)
        code: s
      }
    )

  render: ->
    @$el.html(@template())
    @renderGeneralTab()
    @renderConditionTab()

    @initializeChosen()
    @updateSaveButtonStatus()
    @

  show: ->
    @$el.find('#review_queue_definition-edit-modal').modal('show')

  renderGeneralTab: ->
    @reviewQueueDefinitionGeneralEditView = new Monitoring.Views.ReviewQueueDefinitionGeneralEditView({
      reviewQueueDefinition: @reviewQueueDefinition
      availableUsers: @availableUsers
      availableUsersGroups: @availableUsersGroups
    })
    @$el.find('.tab-content #general').html(@reviewQueueDefinitionGeneralEditView.render().el)
    @listenTo(@reviewQueueDefinitionGeneralEditView, 'changed-mandatory-field', @updateSaveButtonStatus)

  renderConditionTab: ->
    @conditionEditView = new Monitoring.Views.SocialContentConditionEditView({
      socialContentCondition: @reviewQueueDefinition.get('social_content_condition')
      availableTopics: @availableTopics
      availableTags: @availableTags
      availableGroups: @availableGroups
      availableSubtypes: @availableSubtypes
      availableSentiments: @availableSentiments
      editView: @$el
      extendedTagOptions: true
    })
    @$el.find('.tab-content #condition').html(@conditionEditView.render().el)
    @listenTo(@conditionEditView, 'changed-mandatory-field', @updateSaveButtonStatus)
    @listenTo(@conditionEditView, 'reviewQueue:openEditModal', @onOpenEditModal)
    @listenTo(@conditionEditView, 'reviewQueue:closeEditModal', @onCloseEditModal)

  viewsInTabs: ->
    [@reviewQueueDefinitionGeneralEditView, @conditionEditView]

  initializeChosen: ->
    select = @$el.find('.chosen-select')
    select.chosen({
      width: '395px'
      enable_split_word_search: true
      search_contains: true
    });
    chosenDrop = @$el.find('#general .chosen-drop').hide()
    select.on('chosen:showing_dropdown', -> chosenDrop.show())
    select.on('chosen:hiding_dropdown', -> chosenDrop.hide())

  updateSaveButtonStatus: =>
    @$el.find('.save').prop('disabled', !@allMandatoryFieldsAreFilled())

  allMandatoryFieldsAreFilled: =>
    _.all(@viewsInTabs(), (view) -> view.allMandatoryFieldsAreFilled())

  onOpenEditModal: ->
    @$el.find('#review_queue_definition-edit-modal').hide()

  onCloseEditModal: ->
    @$el.find('#review_queue_definition-edit-modal').show()

  onClickSave: ->
    @reviewQueueDefinition.set('social_content_condition', @conditionEditView.getCondition())

    errorOrValid = @reviewQueueDefinition.validateFields()
    if errorOrValid == "VALID"
      @$el.find('.saving').removeClass('invalid-fields').html('Saving...').show()
      @reviewQueueDefinition.save({}, {
        success: (response) =>
          @$el.find('#review_queue_definition-edit-modal').modal('hide')
          @trigger('afterSave', @reviewQueueDefinition)
        error: (response) =>
          @$el.find('.saving').html('Error')
          console.log("Error saving reviewQueueDefinition: #{response}")
      })
    else
      @$el.find('.saving').addClass('invalid-fields').html(errorOrValid).show()
